import { jsxs, jsx } from 'react/jsx-runtime';
import ShortcutKey from './ShortcutKey.js';
import clsx from 'clsx';
import { hasMacOSKbd } from '@fabric-app/utils/detection';

const Shortcut = ({ keybind, icon, modifiers, macModifiers, shadow = false, compact = false, ...props }) => {
  const onMac = hasMacOSKbd();
  const parsedModifiers = [
    onMac && macModifiers?.shift ? "⇧" : !onMac && modifiers.shift ? "⇧" : null,
    onMac && macModifiers?.alt ? "⌥" : !onMac && modifiers.alt ? "Alt" : null,
    onMac && macModifiers?.ctrl ? "⌘" : !onMac && modifiers.ctrl ? "Ctrl" : null,
    onMac && macModifiers?.meta ? "⌘" : !onMac && modifiers.meta ? "Win" : null
  ].filter((value) => value !== null);
  return /* @__PURE__ */ jsxs("div", {
    className: clsx(compact && "text-gray-400 rounded flex gap-[2px] items-center"),
    ...props,
    children: [
      parsedModifiers.map((modifier, index) => /* @__PURE__ */ jsxs("span", {
        className: clsx(!compact ? "text-xs -mr-1 pr-[7px]" : "text-xs"),
        children: [
          /* @__PURE__ */ jsx(ShortcutKey, {
            shadow,
            keybind: modifier,
            compact
          }),
          compact ? "+" : " + "
        ]
      }, index)),
      keybind && /* @__PURE__ */ jsx(ShortcutKey, {
        shadow,
        keybind,
        compact
      }),
      icon
    ]
  });
};

export { Shortcut as default };
//# sourceMappingURL=Shortcut.js.map
